import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import { formatarCpfCnpj, mensagemCpfCnpj, formatarCNPJOnly, mensagemCNPJ } from '../utils/validators';

/**
 * Campo de CPF ou CNPJ com máscara e validação automática.
 * Props:
 *   value, onChange(rawValue), onlyMode="cnpj"|"cpf_cnpj", placeholder, className
 */
export default function CpfCnpjInput({ value = '', onChange, onlyMode = 'cpf_cnpj', placeholder, className = '', ...rest }) {
  const isCNPJOnly = onlyMode === 'cnpj';

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '');
    const maxLen = isCNPJOnly ? 14 : 14;
    if (raw.length > maxLen) return;
    const formatted = isCNPJOnly ? formatarCNPJOnly(e.target.value) : formatarCpfCnpj(e.target.value);
    onChange(formatted);
  };

  const erro = isCNPJOnly ? mensagemCNPJ(value) : mensagemCpfCnpj(value);
  const digits = (value || '').replace(/\D/g, '');
  const isValid = isCNPJOnly
    ? digits.length === 14 && !erro
    : (digits.length === 11 || digits.length === 14) && !erro;
  const showStatus = digits.length > 0;

  return (
    <div className="relative">
      <input
        className={`field-input pr-9 ${erro && digits.length >= (isCNPJOnly ? 14 : 11) ? 'border-red-500/60 focus:border-red-500' : isValid ? 'border-green-500/40 focus:border-green-500' : ''} ${className}`}
        value={value}
        onChange={handleChange}
        placeholder={placeholder || (isCNPJOnly ? '00.000.000/0000-00' : 'CPF ou CNPJ')}
        inputMode="numeric"
        {...rest}
      />
      {showStatus && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          {isValid
            ? <CheckCircle size={15} className="text-green-400" />
            : erro ? <AlertCircle size={15} className="text-red-400" /> : null
          }
        </div>
      )}
      {erro && digits.length >= (isCNPJOnly ? 14 : 11) && (
        <p className="text-xs text-red-400 mt-1">{erro}</p>
      )}
    </div>
  );
}
